import React from "react";
import { FiMapPin, FiAlertTriangle } from "react-icons/fi";
import DummyPlacesAutocomplete from "../../common/DummyPlacesAutocomplete";
import { Label } from "./fields";

const GOOGLE_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const hasCoord = (x) => x !== "" && x != null;

/**
 * "As per Google Map" picker for one end of the trip (`side` is "pickup" or
 * "drop"). Suggestions come from all of India, ranked towards the booking's
 * city, so airports on the city edge and outstation drops can still be found.
 */
export default function MapAddressField({
  side,
  v,
  city,
  readOnly,
  placeIssue,
  onPlaceTyping,
  onPlaceSelect,
  placeholder,
}) {
  const text = v[`${side}GoogleAddr`] || "";
  const pinned = hasCoord(v[`${side}Lat`]) && hasCoord(v[`${side}Lng`]);

  return (
    <div data-field={`${side}GoogleAddr`}>
      <Label>As per Google Map (optional)</Label>
      <DummyPlacesAutocomplete
        key={`${side}-${v[`${side}Mode`]}`}
        apiKey={GOOGLE_KEY}
        value={text}
        onChange={(val) => onPlaceTyping(side, val)}
        onSelect={(place) => onPlaceSelect(side, place)}
        placeholder={placeholder}
        city={city}
        readOnly={readOnly}
      />

      {placeIssue ? (
        <div className="mt-1.5 flex items-start gap-1.5 text-[12px] text-amber-700 dark:text-amber-400">
          <FiAlertTriangle className="w-3.5 h-3.5 mt-0.5 shrink-0" />
          <span>{placeIssue} Distance can't be calculated automatically for this address; enter it manually if needed.</span>
        </div>
      ) : pinned && text ? (
        <div className="mt-1.5 flex items-start gap-1.5 text-[12px] text-slate-600 dark:text-slate-300">
          <FiMapPin className="w-3.5 h-3.5 mt-0.5 shrink-0 text-emerald-600 dark:text-emerald-400" />
          <span className="break-words">{text}</span>
        </div>
      ) : text && !readOnly ? (
        <div className="mt-1.5 text-[11px] text-slate-500 dark:text-slate-400">
          Pick one of the suggestions to pin the exact location.
        </div>
      ) : null}
    </div>
  );
}
